import icArrowUpRightGrey from 'assets/images/ic-arrow-up-right-grey.svg'
import icArrowUpRightWhite from 'assets/images/ic-arrow-up-right-white.svg'
import icDocumentUploadGreen from 'assets/images/ic-document-upload-green.svg'
import icDocumentUploadGrey from 'assets/images/ic-document-upload-grey.svg'
import icDocumentUpload from 'assets/images/ic-document-upload-primary.svg'
import icDownload01 from 'assets/images/ic-download-primary.svg'
import icUpload03 from 'assets/images/ic-upload-primary.svg'
import icXGrey from 'assets/images/ic-x-grey.svg'
import clsx from 'clsx'
import Button from 'components/commons/button'
import Checkbox from "components/commons/checkbox"
import Toast from 'components/commons/toast'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { useFetch } from 'services/useFetch.js'
import { downloadFile, getFileUnit } from 'utils/utils.js'
import { useImport } from '../ImportContext.jsx'

export const UploadFile = () => {
    const { statusSync, title, details, api, initialPayload, downloadTemplatePayload, setActiveStep, setPayload } = useImport()
    const uploadFileRef = useRef()
    const [isDragOver, setIsDragOver] = useState(false)
    const [sourceFile, setSourceFile] = useState({})
    const [isUpdate, setIsUpdate] = useState(false)
    const { fetching: getTemplate, isLoading } = useFetch(api?.fetchTemplate)
    const { fetching: getStatus } = useFetch(api?.fetchStatusImport)

    useEffect(() => {
        if (!api?.fetchStatusImport) return
        ;(async () => {
            const response = await getStatus()
            if (response?.data?.status !== statusSync[0]) setActiveStep(4)
        })()
    }, [])

    const onClickDownload = async () => {
        const response = await getTemplate(downloadTemplatePayload, '', {}, 'blob')
        downloadFile(null, response, `Template-Import-${title?.replaceAll(' ', '-')}-${moment().format('DD-MM-YYYY')}.xlsx`)
    }

    const cancelUploadFile = () => {
        setSourceFile({})
        setIsUpdate(false)
    }

    const onChangeUploadFile = (e) => {
        const allowedExtension = /(\.xlsx)$/i
        const sourceUploadFile = e.dataTransfer?.files[0] || e.target?.files[0]
        if (!allowedExtension.exec(sourceUploadFile?.name)) {
            Toast({ message: 'Wrong Extension!' })
        } else if (sourceUploadFile?.size > 64e6) {
            Toast({ message: 'Invalid size!' })
        } else {
            setSourceFile(sourceUploadFile)
        }
    }

    const onDragAndDrop = (e) => {
        e.preventDefault()
        const eventType = e?.type

        switch (eventType) {
            case 'drop':
                onChangeUploadFile(e)
                setIsDragOver(false)
                break
            case 'dragover':
                setIsDragOver(true)
                break
            default:
                setIsDragOver(false)
        }
    }

    const getIconDocumentUpload = () => {
        if (isDragOver) {
            return icDocumentUpload
        } else if (sourceFile?.name) {
            return icDocumentUploadGreen
        } else {
            return icDocumentUploadGrey
        }
    }

    const onSubmitFile = () => {
        setPayload({
            ...initialPayload,
            file: sourceFile,
            ...(initialPayload?.is_update !== undefined && { is_update: isUpdate }),
        })
        setActiveStep(2)
    }

    useEffect(() => {
        setSourceFile(initialPayload?.file)
    }, [initialPayload?.file])

    return (
        <div className='flex flex-col space-y-4 w-full px-40'>
            <div
                className={clsx(
                    'flex flex-col space-y-2 pb-2 text-neutral-80',
                    details?.length && 'border-b border-b-neutral-20',
                )}
            >
                {Object.values(details).map((item) => (
                    <p key={item.value}>
                        <span className='font-semibold'>{item.label}:</span> {item.value}
                    </p>
                ))}
            </div>
            <div className='row justify-between items-center'>
                <div className='flex flex-col space-y-2 text-neutral-80'>
                    <p className='font-semibold'>Import File XLSS File</p>
                    <p>{`This tools allows you to import for merge ${title} data to ${title} list from a XLSX file.`}</p>
                </div>
                <Button
                    type='outline'
                    title='Download Template'
                    icon={icDownload01}
                    onClick={onClickDownload}
                    loading={isLoading}
                />
            </div>
            <div
                onDrop={(e) => onDragAndDrop(e)}
                onDragOver={(e) => onDragAndDrop(e)}
                onDragLeave={(e) => onDragAndDrop(e)}
                className={clsx(
                    'flex flex-col space-y-4 px-5 border-2 border-dashed rounded-lg',
                    sourceFile?.name ? 'pt-16' : 'py-16',
                    isDragOver ? 'bg-primary-10 border-primary-40' : 'bg-neutral-10 border-neutral-40',
                )}
            >
                <img src={getIconDocumentUpload()} alt='ic-document-upload' className='mx-auto' />
                {sourceFile?.name ? (
                    <>
                        <div className='flex flex-col space-y-4 items-center'>
                            <p className='font-semibold'>{sourceFile?.name}</p>
                            <p className='text-neutral-70'>{getFileUnit(sourceFile?.size)}</p>
                        </div>
                        <div className='row justify-end pb-7'>
                            <Button type='outline' title='Cancel' icon={icXGrey} onClick={() => cancelUploadFile()} />
                        </div>
                    </>
                ) : (
                    <div className='flex flex-col space-y-4 items-center'>
                        <div className='row space-x-4 items-center'>
                            <p className={`font-semibold ${isDragOver ? 'text-primary-50' : 'text-inherit'}`}>
                                Drag File Here or
                            </p>
                            <div className='relative'>
                                <Button
                                    type='outline'
                                    title='Upload File'
                                    icon={icUpload03}
                                    onClick={() => uploadFileRef.current.click()}
                                />
                                <input
                                    type='file'
                                    accept='.xlsx'
                                    className='absolute top-0 hidden'
                                    ref={uploadFileRef}
                                    onChange={onChangeUploadFile}
                                />
                            </div>
                        </div>
                        <p className='text-neutral-60'>XLSX File format, and maximum size 64 mb</p>
                    </div>
                )}
            </div>
            {initialPayload?.is_update !== undefined && (
                <div className={'flex flex-row justify-between items-center'}>
                    <p className='font-medium'>{`Update Existing ${title} Data`}</p>
                    <Checkbox
                        name='isUpdate'
                        checked={isUpdate}
                        label={
                            <p className='whitespace-pre-line'>
                                {`Existing ${title} records that match by ID or Name will be Updated.\n ${title} records that do not match any existing data will be Skipped.`}
                            </p>
                        }
                        onChange={({ checked }) => setIsUpdate(checked)}
                    />
                </div>
            )}
            <Button
                className='mt-8 px-12 w-fit ml-auto'
                title='Validate Data'
                disabled={!sourceFile?.name}
                icon={sourceFile?.name ? icArrowUpRightWhite : icArrowUpRightGrey}
                onClick={onSubmitFile}
            />
        </div>
    )
}
